import * as React from "react";
import CloudDownload from "@material-ui/icons/CloudDownload";
import TableStyle from "../shared/Styling/TableStyling";
import { CircularProgress } from "@material-ui/core";

interface ID {
    onDocumentDownload(): void;
}

const DocumentDownloadButton: React.FC<ID> = ({ onDocumentDownload }) => {
    const classes = TableStyle();
    const [isDownloading, setDownloading] = React.useState(false);

    const tryToKill = async () => {
        setDownloading(true);
        try {
            await onDocumentDownload();
        } finally {
            setDownloading(false);
        }
    };

    if (isDownloading) {
        return <CircularProgress className={`${classes.icon}`} />;
    }

    return (
        <CloudDownload
            onClick={tryToKill}
            className={`${classes.button} ${classes.icon}`}
        />
    );
};

export default DocumentDownloadButton;
